import colors from '../colors';
import styled from 'styled-components';
import * as React from 'react';
import { MessageWithMetadata } from '../../typedefs/store';
import * as AlertIcon from 'react-icons/lib/io/alert-circled';
import * as SendIcon from 'react-icons/lib/io/ios-paperplane';

interface Props {
    message: MessageWithMetadata;
    retrySend: (message: MessageWithMetadata) => void;
}
interface State {}

export class MessageSendError extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.resend = this.resend.bind(this);
    }

    resend(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.props.retrySend(this.props.message);
    }

    render() {
        if (this.props.message.sending) {
            return (
                <RetryingWrapper>
                    <SendIcon size={18} style={{ marginRight: 3 }} />Retrying your message.
                </RetryingWrapper>
            );
        }

        return (
            <Wrapper>
                <AlertIcon style={{ marginRight: 3 }} />
                <A href="#" onClick={this.resend}>
                    Error sending message. Click to retry.
                </A>
            </Wrapper>
        );
    }
}

export default MessageSendError;

const Wrapper = styled.div`
    display: flex;
    color: ${colors.red};
    align-items: center;
    justify-content: center;
    margin-top: 5px;
`;

const A = styled.a`
    color: ${colors.red};
    text-decoration: none;
    &:hover,
    &:active,
    &.focus {
        color: ${colors.red};
    }
`;

const RetryingWrapper = styled.div`
    display: flex;
    color: ${colors.mediumDarkGray};
    align-items: center;
    justify-content: center;
    margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/MessageSendError.tsx